// Module
var code = `<div class="modal-window-content-section">

  <div class="modal-window-content-body">



  </div>
</div>
`;
// Exports
module.exports = code;